import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LayoutComponent } from './layout/layout.component';
import { CoreRoutingModule } from './core-routing.module';
import { NgxsModule } from '@ngxs/store';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import {
  FontsLoaderComponent,
  LearnizState,
  TextsState,
  ToggleReadSpeakerVisibilityModule,
  WordingModule,
} from '@jump-tools-front/shared';
import { PrivacyComponent } from '@jumpbiz/jump-rgpd';

@NgModule({
  exports: [CoreRoutingModule, LayoutComponent],
  imports: [
    CommonModule,
    CoreRoutingModule,
    NgxsModule.forFeature([LearnizState, TextsState]),
    PrivacyComponent,
    WordingModule,
    FontsLoaderComponent,
    ToggleReadSpeakerVisibilityModule,
    LayoutComponent,
  ],
  providers: [provideHttpClient(withInterceptorsFromDi())],
})
export class CoreModule {}
